import { $, $$, show, esc, postQuote } from './_helpers'

const { __, sprintf } = wp.i18n

// Quick request and quick / expert switch — independent of the expert path.
export const initQuick = (root) => {
  const OPT = window.vnQuote.options
  const TOKEN = window.vnQuote.token
  const PHONE = window.vnQuote.phone
  const form = $('#quickForm')
  if (!form) return
  const f = (k) => $(`[data-q="${k}"]`, form)

  /* quick / expert switch */
  function setMode(m) {
    root.classList.toggle('pt-quote--quick', m === 'rapide')
    $$('.mode-switch button', root).forEach((b) =>
      b.setAttribute('aria-pressed', String(b.dataset.mode === m))
    )
  }
  $$('.mode-switch button', root).forEach((b) =>
    b.addEventListener('click', () => {
      setMode(b.dataset.mode)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  )
  setMode(window.vnQuote.mode === 'rapide' ? 'rapide' : 'expert')

  /* 2-page navigation */
  let step = 1,
    product = '',
    qFamily = ''
  const nextLabel = () =>
    step === 2 ? __('Send my request', 'vn') : __('Next →', 'vn')
  function go(n) {
    step = n
    $$('.qstep', form).forEach((s) => show(s, +s.dataset.q === n))
    $$('.q-progress span', form).forEach((s, i) => s.classList.toggle('on', i < n))
    /* translators: 1: step number, 2: number of steps */
    $('#qCount').textContent = sprintf(__('Step %1$d of %2$d', 'vn'), n, 2)
    $('#qPrev').style.visibility = n === 1 ? 'hidden' : 'visible'
    $('#qNext').textContent = nextLabel()
    show($('#qErr'), false)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  /* product -> formats (with dimensions), pages, description, papers */
  const qOpts = (o, sel) =>
    Object.entries(o)
      .map(([k, v]) => `<option value="${k}" ${k == sel ? 'selected' : ''}>${esc(v)}</option>`)
      .join('')
  function renderPapers() {
    const P = OPT.profiles[product] || {}
    const parts = P.pages ? [__('Cover', 'vn'), __('Interior', 'vn')] : [__('Paper', 'vn')]
    const prev = {}
    // keep what the customer chose, otherwise the product preselection
    $$('.qpaper[data-touched]', form).forEach((r) => {
      prev[r.dataset.part] = { t: $('.qp-type', r).value, g: $('.qp-gram', r).value }
    })
    const dontKnow = esc(__('I don\'t know', 'vn'))
    $('#qPapers').innerHTML = parts
      .map((p) => {
        const c = prev[p] || { t: P.paper, g: String(P.grammage ?? '') }
        return `<div class="qpaper" data-part="${esc(p)}"${prev[p] ? ' data-touched' : ''}>${parts.length > 1 ? `<div class="qpaper-name">${esc(p)}</div>` : ''}<div class="pt-quote__grid">
        <div class="field"><label>${esc(__('Paper type', 'vn'))}</label><select class="qp-type"><option value="conseil">${dontKnow}</option>${qOpts(OPT.papers, c.t)}</select></div>
        <div class="field"><label>${esc(__('Grammage', 'vn'))}</label><select class="qp-gram"><option value="conseil">${dontKnow}</option>${OPT.grammages.map((g) => `<option value="${g}" ${String(g) === c.g ? 'selected' : ''}>${g} g/m²</option>`).join('')}</select></div>
      </div></div>`
      })
      .join('')
  }
  $$('#qProductList .tile').forEach((t) =>
    t.addEventListener('click', () => {
      product = t.dataset.qprod
      qFamily = t.dataset.family
      $$('#qProductList .tile').forEach((x) => x.classList.toggle('on', x === t))
      const P = OPT.profiles[product] || {}
      const keys = P.formats && P.formats.length ? P.formats : Object.keys(OPT.formats)
      const sel = $('#qFormat'),
        prev = sel.value
      sel.innerHTML =
        `<option value="">${esc(__('— Choose —', 'vn'))}</option>` +
        keys.map((k) => `<option value="${k}">${esc(OPT.formats[k].label)}</option>`).join('') +
        `<option value="autre">${esc(__('Other format (specify)', 'vn'))}</option>`
      if (keys.includes(prev) || prev === 'autre') sel.value = prev
      show($('#qCustomBox'), sel.value === 'autre')
      show($('#qPagesBox'), !!P.pages)
      show($('#qDescBox'), qFamily === 'autre')
      $('#qFormatLabel').textContent = P.pages
        ? __('Finished format (closed)', 'vn')
        : __('Finished format', 'vn')
      show($('#qFormatHint'), !!P.pages)
      renderPapers()
      clearErr($('#qProductList'))
    })
  )
  $('#qFormat').addEventListener('change', (e) =>
    show($('#qCustomBox'), e.target.value === 'autre')
  )
  $('#qPapers').addEventListener('change', (e) => {
    e.target.closest('.qpaper')?.setAttribute('data-touched', '')
  })
  renderPapers()
  $('#qDate').min = new Date().toISOString().slice(0, 10)

  /* errors */
  function mark(el, msg) {
    el.classList.add('invalid')
    const m = document.createElement('div')
    m.className = 'err-msg'
    m.textContent = msg
    ;(el.closest('.field') || el.parentElement).append(m)
  }
  function clearErr(el) {
    el.classList.remove('invalid')
    ;(el.closest('.field') || el.closest('fieldset') || el.parentElement)
      .querySelectorAll('.err-msg')
      .forEach((m) => m.remove())
  }
  form.addEventListener('input', (e) => {
    if (e.target.classList.contains('invalid') && String(e.target.value).trim()) clearErr(e.target)
  })
  form.addEventListener('change', (e) => {
    if (e.target.classList.contains('invalid') && String(e.target.value).trim()) clearErr(e.target)
  })

  function validate(n) {
    const s = $(`.qstep[data-q="${n}"]`, form)
    $$('.invalid', s).forEach((e) => e.classList.remove('invalid'))
    $$('.err-msg', s).forEach((e) => e.remove())
    const need = (el, msg) => {
      if (!String(el.value).trim()) mark(el, msg)
    }
    if (n === 1) {
      need(f('contact.lastName'), __('Last name is required', 'vn'))
      need(f('contact.phone'), __('Phone is required', 'vn'))
      const em = f('contact.email')
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value)) mark(em, __('Invalid email', 'vn'))
    } else {
      const P = OPT.profiles[product] || {}
      if (!product) mark($('#qProductList'), __('Choose a product', 'vn'))
      if (qFamily === 'autre') need(f('quick.description'), __('Describe your project', 'vn'))
      if (!(+f('quick.quantity').value > 0)) mark(f('quick.quantity'), __('Enter a quantity', 'vn'))
      need(f('quick.format'), __('Choose a format', 'vn'))
      if (f('quick.format').value === 'autre') {
        if (!(+f('quick.width').value > 0)) mark(f('quick.width'), __('Width?', 'vn'))
        if (!(+f('quick.height').value > 0)) mark(f('quick.height'), __('Height?', 'vn'))
      }
      if (P.pages && !(+f('quick.pages').value >= 4))
        mark(f('quick.pages'), __('Enter the number of pages', 'vn'))
    }
    const first = $('.invalid', s)
    if (first) {
      $('#qErr').textContent = __('Please complete the highlighted fields.', 'vn')
      show($('#qErr'), true)
      first.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return false
    }
    return true
  }

  async function submit() {
    const btn = $('#qNext')
    show($('#qErr'), false)
    btn.disabled = true
    btn.textContent = __('Sending…', 'vn')
    const data = {
      mode: 'rapide',
      formToken: TOKEN,
      website: $('input[name=vn_extra_field]', form).value,
      contact: {
        lastName: f('contact.lastName').value,
        firstName: f('contact.firstName').value,
        email: f('contact.email').value,
        phone: f('contact.phone').value,
        company: f('contact.company').value,
      },
      quick: {
        product,
        quantity: +f('quick.quantity').value,
        format: f('quick.format').value,
        width: +f('quick.width').value || null,
        height: +f('quick.height').value || null,
        pages: +f('quick.pages').value || null,
        description: f('quick.description').value,
        orientation: $('#quickForm .fmt-orient')?.dataset.value || 'portrait',
        sides: $('input[name=qSides]:checked', form).value,
        papers: $$('.qpaper', form).map((r) => ({
          part: r.dataset.part,
          type: $('.qp-type', r).value,
          grammage: $('.qp-gram', r).value,
        })),
        postalCode: f('quick.postalCode').value.trim(),
        date: f('quick.date').value,
        message: f('quick.message').value,
      },
    }
    try {
      const r = await postQuote(data)
      if (r.ok) {
        $$('.qstep', form).forEach((s) => show(s, false))
        show($('#qNav'), false)
        show($('#qHead'), false)
        $('.mode-switch', root).style.display = 'none'
        $('#qDoneRef').textContent = r.reference
        show($('#qDone'), true)
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      const errs = r.errors || {}
      if (Object.keys(errs).some((k) => k.startsWith('contact.'))) go(1)
      $('#qErr').textContent = Object.values(errs).join(' — ')
      show($('#qErr'), true)
    } catch (e) {
      $('#qErr').textContent = sprintf(
        /* translators: %s: phone number */
        __('Sending is not possible at the moment. Please try again or call us on %s.', 'vn'),
        PHONE
      )
      show($('#qErr'), true)
    }
    btn.disabled = false
    btn.textContent = nextLabel()
  }

  $('#qPrev').addEventListener('click', () => go(step - 1))
  $('#qNext').addEventListener('click', () => {
    if (!validate(step)) return
    step === 2 ? submit() : go(2)
  })
  go(1)
}
